import { generatePath } from 'react-router-dom'
import { api } from '../config/api'
import { default_token } from '../config/config'
import store from '../config/store'
import {
  generateApiUrl,
  generateApiUrlWithGetParams,
  generateGetApiUrl,
} from '../utils/urlHelpers'
import { Methods, makeRequest } from './Request'

export const listScreensSelect = (params = {}) => {
  const url = generateApiUrlWithGetParams(api.routes.screens.list_select, params)
  return makeRequest(url, Methods.GET)
}

export const getScreens = (params, forceCompany) => {
  let url = generateGetApiUrl(api.routes.screens.list, params)
  const { currentCompany } = store.getState().auth

  if (currentCompany || forceCompany) {
    url = generateApiUrlWithGetParams(api.routes.screens.listCompany, { companyId: forceCompany || currentCompany.id }, false, params)
  }

  return makeRequest(url, Methods.GET)
}

export const getScreen = (params) => {
  let url = null

  if (params?.id) {
    url = generateApiUrl(api.routes.screens.get, { id: params?.id })
  } else {
    url = api.routes.screens.pre_create
  }

  return makeRequest(url, Methods.GET)
}

export const updateScreen = (values) => {
  let url = api.routes.screens.update

  if (values?.id) {
    url += `/${values.id}`
  }

  return makeRequest(url, Methods.PATCH, values)
}

export const preAssociateFlow = (screen, flow) => {
  const url = generateApiUrl(api.routes.screens.preAssociate, { screen, flow })
  return makeRequest(url, Methods.POST)
}

export const associateScreen = (token, uuid, flow_id) => {
  const url = generateApiUrl(api.routes.screens.associate, { token, uuid })
  return makeRequest(
    url,
    Methods.POST,
    flow_id ? { flow_id, method: 'code' } : { method: 'code' },
    {
      Authorization: default_token,
      referer: `${window.location.origin}/associate_screen/${uuid}`,
    }
  )
}

export const rawAssociateScreen = (token, uuid) => {
  const url = generateApiUrl(api.routes.screens.associate, { token, uuid })
  return makeRequest(
    url,
    Methods.POST,
    { method: 'qrcode' },
    {
      Authorization: default_token,
      referer: `${window.location.origin}/associate_screen/${uuid}`,
    }
  )
}

export const sendScreenCommand = (token, command) => {
  const route = api.routes.screens?.commands[command]
  const url = generateApiUrl(
    route || api.routes.screens.sendCommand,
    route ? { token } : { token, command }
  )
  return makeRequest(url, Methods.POST, {})
}

export const addFreeScreen = (companyId) => {
  const url = generatePath(api.routes.screens.addFree, { companyId })
  return makeRequest(url, Methods.POST)
}

export const deleteFreeScreen = (companyId) => {
  const url = generatePath(api.routes.screens.deleteFreeScreen, { companyId })
  return makeRequest(url, Methods.DELETE)
}

export const adminDissociateScreen = (id) => {
  const url = generatePath(api.routes.screens.admin.dissociateScreen, { id })
  return makeRequest(url, Methods.POST)
}

export const adminDissociateFlow = (id) => {
  const url = generatePath(api.routes.screens.admin.dissociateFlow, { id })
  return makeRequest(url, Methods.POST)
}

export const deleteMultiScreens = (subId, companyId, idScreens) => {
  const url = generatePath(api.routes.screens.deleteMulti, { subId, companyId })
  return makeRequest(url, Methods.DELETE, { screens: idScreens })
}

export const getLogsApp = (id, params) => {
  const url = generateApiUrlWithGetParams(api.routes.screens.logsApp, id, null, params)
  return makeRequest(url, Methods.GET, null, null, true)
}

export const getScreenshotsApp = (id) => {
  const url = generateApiUrlWithGetParams(api.routes.screens.getScreenshots, id)
  return makeRequest(url, Methods.GET, null, null, true)
}

export const takeScreenShot = (id) => {
  const url = generateApiUrlWithGetParams(api.routes.screens.takeScreenshot, id)
  return makeRequest(url, Methods.GET, null, null, true)
}
